export default __webpack_public_path__ + "static/media/favicon.d082632c.ico";